import { InputMask, InputMaskProps } from 'primereact/inputmask';
import React from 'react';
import { PInputMaskStyle as S } from './PInputMask.style';

export const PInputMask = React.forwardRef<InputMask, InputMaskProps>((props, ref) => {
  return <S.InputMask {...props} ref={ref} />;
});
